module.exports = __webpack_public_path__ + "img/katarina_living_room_4.0d4fc7f7.jpg";